import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-25ecd0ca"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "receipt-container"
};
const _hoisted_2 = {
  class: "receipt-header"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "success-icon",
  src: "https://p6.moimg.net/mdwxapp/pay/gold_pay_success_icon.png",
  alt: "支付成功"
}, null, -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "success-text"
}, "支付成功", -1));
const _hoisted_5 = {
  class: "success-amount"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "¥", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _hoisted_4, _createElementVNode("div", _hoisted_5, [_hoisted_6, _createTextVNode(_toDisplayString($data.orderInfo.pay_amount || ' '), 1)])]), _createElementVNode("div", {
    class: "action-button",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.handleClickAction && $options.handleClickAction(...args))
  }, _toDisplayString($data.orderInfo.is_card ? '去拆卡' : '完成'), 1)]);
}